import { render, staticRenderFns } from "./nbn-appointment-details.vue?vue&type=template&id=39c88056&scoped=true"
import script from "./nbn-appointment-details.vue?vue&type=script&lang=js"
export * from "./nbn-appointment-details.vue?vue&type=script&lang=js"
import style0 from "./nbn-appointment-details.vue?vue&type=style&index=0&id=39c88056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c88056",
  null
  
)

export default component.exports